<section class="NavToolbar">
  <div class="container u-maxY">
    @if (data.isUserLoggedIn) {
      <div class="u-flex u-alignCenter u-justifyEnd u-maxY">
        <!-- Used for Member Policy Dropdown -->
        @if (config.dropdown) {
          <dropdown
            [options]="config.dropdown?.options"
            [value]="config.dropdown?.selectedOption?.id"
            [displayProperty]="config.dropdown.displayProperty"
            [disabled]="
              config.dropdown?.options?.length === 1 &&
              !config.dropdown.isDisabled
            "
            key="id"
            (selectOption)="selectOption($event)"
            data-test-id="policySelector"
            class="NavToolbar__Dropdown"
          ></dropdown>
        }
        <language-dropdown
          [config]="config.languagesSwitcher"
          [activeLangKey]="activeLangKey"
          (languageSwitched)="handleSwitchLanguageClicked($event)"
          class="NavToolbar__Dropdown"
        ></language-dropdown>
        <nav-icons
          (navItemClicked)="navItemClicked.emit($event)"
          (navMenuToggled)="navMenuClicked.emit($event)"
          [data]="data"
          class="u-maxY"
        >
        </nav-icons>
      </div>
    }
  </div>
</section>
